import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Breadcrumb, BreadcrumbItem, CardHeader } from 'reactstrap';
import moment from 'moment';
import 'moment-timezone';

import classnames from 'classnames';
import Capability from './Capability';
import { Beforeunload } from 'react-beforeunload';
import { Typeahead } from 'react-bootstrap-typeahead';
import axios, { post } from 'axios';
import * as FileSaver from 'file-saver';
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactGA from 'react-ga';
import config from '../../config/okta.config';
import {
  Nav, NavItem, NavLink, Modal, ModalHeader, ModalBody, ModalFooter, Progress, FormFeedback,Row,
  InputGroup, FormGroup, Label, Input, ButtonToggle, Spinner, UncontrolledTooltip, TabContent, TabPane
} from 'reactstrap';

import FileUploaderObjGeneric from './fileuploaderGeneric'
import XLSX from 'xlsx';
import {
  Col,
  Card,CardTitle,CardText,
  CardBody, Button, InputGroupAddon
} from 'reactstrap';
import { Form, FormText } from 'reactstrap';
import { withAuth } from '@okta/okta-react';

import gql from 'graphql-tag';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import { ConstantLine } from 'devextreme-react/chart';
import DataTable from 'react-data-table-component'

const GET_NOTIFICATIONS = gql`
      query getInspections($Vendor: String, $NotifType: String, $VendorResponsible: String){
        vwNotificationsvr(filters: {
            NotifType: $NotifType
            VendorIlike: $Vendor
            VendorResponsible: $VendorResponsible
          }, sort: CREATED_DATE_DESC) { 
            edges {
              node {
                NotifNum
                NotifType
                NotifDate
                NotifOrigin
                NotifStatus
                NotifSubType
                InspLotNum
                MaterialNum
                RevLvl
                
                Vendor
                VendorName
                VendorMaterialNum
                VendorResponsible
                Severity
                AssetNum
                Description
                QmOrder
                ActualQty
                RefQty
                VendorMaterialNum
                Manufacturer
                CreatedBy
                CreatedDate
                ChangedBy
                ChangedDate
                BuyerDescr
                ComplaintQty
                PurchaseOrderNum
                MfgCell
              }
            }
          }
        }
  

  `;


  const GET_NOTIFICATION_TASKS = gql`
      query getNotificationTasks($NotifNum: ID){
        vwNotificationtasks(filters: {
            NotifNum: $NotifNum
           
          }) { 
            edges {
              node {
                NotifNum
                TaskNum
                SAPTaskNum
                TaskStatus
                CatalogTypeTasks
                CodeGroupTask
                TaskCode
                TaskCodeText
                TaskText
                CompletedBy
                Responsible
                CompletionDate
                PlannedStartDate
                PlannedEndDate
                PlannedStartTime
                PlannedEndTime
                Version
                ChangedBy
                ChangedOn
                CreatedOn
                DWLoadTS
                DWUpdateTS
              }
            }
          }
        }
  

  `;

  const GET_NOTIFICATION_TEXT = gql`
      query vwNotificationstasktext($NotifNum: ID){
        vwNotificationstasktext(filters: {
            NotifNum: $NotifNum
           
          }) { 
            edges {
              node {
                NotifNum
                    TaskNum
                    SRTF2
                    TaskText
                    Clustr
                    TDObject
              }
            }
          }
        }
  

  `;



//Start main code
const VRNotifications = ({ history }) => {
    const [showLoading, setShowLoading] = useState(null);
    const [NotificationData, setNotificationData] = useState(null);
    const [notificationText,setNotificationText] = useState(null);
    const [notificationTasks,setNotificationTasks] = useState(null);
    const [selectedNotification,setSelectedNotification] = useState(null);
    const [activeTab, setActiveTab] = useState('1');

      // Get list of OPEN PO for the logged in vendor
  const { data } = useQuery(GET_NOTIFICATIONS, {
    fetchPolicy: 'no-cache',
    variables: { Vendor: '%' + localStorage.getItem('loggedInVendor'), 'NotifType': 'VR','VendorResponsible':'Y' }, // NotifiType: NR, NotifSubtype: 'SC'
    onCompleted: (data) => {
       
        setShowLoading(false);
        setNotificationData(data.vwNotificationsvr.edges);
       
    }
  });

        useEffect(() => {
        if (!NotificationData) {
            setShowLoading(true);
        } else {
            setShowLoading(false);
        }
        });

    const navigateHome = () => {
   
        history.push({
          pathname: '/supplier/LandingPage'
        });
     
    }

    const navigateVRNotif = () => {
        setNotificationTasks(null);
        setNotificationText(null);
        history.push({
            pathname: '/supplier/VRNotifications'
          });
    }

    const taskcolumns = [
        {
            name: 'TaskNum',
            selector: 'node.TaskNum',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, 
        {
          name: 'TaskCode',
          selector: 'node.TaskCode',
          sortable: true,
          style: {
              color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        }, {
            name: 'TaskCodeText',
            selector: 'node.TaskCodeText',
            grow:2,
            format: (row) =>  <span>{row.node.TaskCodeText}</span>,    
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'TaskStatus',
            selector: 'node.TaskStatus',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'TaskText',
            selector: 'node.TaskText',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'CodeGroupTask',
            selector: 'node.CodeGroupTask',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'PlannedStartDate',
            selector: 'node.PlannedStartDate',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'PlannedEndDate',
            selector: 'node.PlannedEndDate',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'CreatedOn',
            selector: 'node.CreatedOn',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'CompletedBy',
            selector: 'node.CompletedBy',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'CompletionDate',
            selector: 'node.CompletionDate',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }, {
            name: 'ChangedBy',
            selector: 'node.ChangedBy',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          },{
            name: 'ChangedOn',
            selector: 'node.ChangedOn',
            sortable: true,
            style: {
                color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          }]




    const columns = [
        {
          name: 'Notification #',
          selector: 'node.NotifNum',
          sortable: true,
          style: {
              color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Description',
          selector: 'node.Description',
          selector: 'ILStartDate',
          format: (row) =>  <span>{row.node.Description}</span>,    
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Material #',
          selector: 'node.MaterialNum',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Revision',
          selector: 'node.RevLvl',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        }, {
            name: 'Status',
            selector: 'node.NotifStatus',
            sortable: true,
            style: {
              color: '#202124',
              fontSize: '14px',
              fontWeight: 500,
            }
          },
        {
          name: 'Created By',
          selector: 'node.CreatedBy',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Created Date',
          selector: 'node.CreatedDate',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Actual Qty',
          selector: 'node.ActualQty',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },
        {
          name: 'Severity',
          selector: 'node.Severity',
          sortable: true,
          style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
          }
        },{
            name: '',
            button: true,
            cell: (row) => <button onClick={() => viewNotification(row)} style={{marginLeft:'15px',width:'100px',color:'white',backgroundColor:'blue'}}>View</button>,
          }
        ];

        const [getNotificationTasks] = useLazyQuery(GET_NOTIFICATION_TASKS, {
            fetchPolicy: 'no-cache',
            onCompleted: (data) => {
              setNotificationTasks(data.vwNotificationtasks.edges);
            
            }
          });

          const [getNotificationText] = useLazyQuery(GET_NOTIFICATION_TEXT, {
            fetchPolicy: 'no-cache',
            onCompleted: (data) => {
              setNotificationText(data.vwNotificationstasktext.edges);
            
            }
          });
  
const viewNotification = (row) => {
    setSelectedNotification(row);
    getNotificationText({ variables: { NotifNum: row.node.NotifNum } });
    getNotificationTasks({ variables: { NotifNum: row.node.NotifNum } });
}


const notesHTML = (!notificationText) ? null : 
    notificationText.map((el,i) => {
        return (
        <li>{el.node.TaskText}</li>
        )
    });

    


const VRDetailHeader = (!selectedNotification) ? null :
<table className="align-middle mb-0 table table-borderless table-striped table-hover">
    <thead>
        <tr>
            <th>Notification #</th>
            <th>Notification Type/SubType</th>
            <th>Material #</th>
            <th>Problem Description</th>
            <th>Created Date</th>
            <th>Created By</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td style={{textAlign:'center'}}>{selectedNotification.node.NotifNum}</td>
            <td style={{textAlign:'center'}}>VR / {selectedNotification.node.MfgCell}</td>
            <td style={{textAlign:'center'}}>{selectedNotification.node.MaterialNum}</td>
            <td style={{textAlign:'center'}}>{selectedNotification.node.Description}</td>
            <td style={{textAlign:'center'}}>{selectedNotification.node.CreatedDate}</td>
            <td style={{textAlign:'center'}}>{selectedNotification.node.CreatedBy}</td>
           
        </tr>
    </tbody>
</table>;

const toggle = tab => {
    console.log(tab)
    if (activeTab !== tab) setActiveTab(tab);
  }


return (
    <Fragment>
      <Beforeunload onBeforeunload={() => "You'll lose your data!"} />

      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >

<Breadcrumb>
          <BreadcrumbItem style={{ paddingTop: "0.5rem" }}>
            <a href="javascript:void(0);" onClick={navigateHome}>
              Home
            </a>{" "}
          </BreadcrumbItem>
          <BreadcrumbItem style={{ paddingTop: "0.5rem" }} active>
          <a href="javascript:void(0);" onClick={navigateVRNotif}> VR Notifications </a>
          </BreadcrumbItem>
            {(notificationTasks && notificationText)?
          <BreadcrumbItem style={{ paddingTop: "0.5rem" }} active>
            VR Details
          </BreadcrumbItem>: null}

          </Breadcrumb>
          { (NotificationData && (!notificationTasks || !notificationText)) ?
          <Card style={{margin:'2%'}}>
            <CardHeader>VR Notifications</CardHeader>

            <CardBody>
            <div className="table-responsive">
                          <DataTable
                            title="Google Sheets-esqe"
                            columns= {columns}
                            data={NotificationData}
                            highlightOnHover                 
                            pointerOnHover
                            pagination
                          />
                  </div>

            </CardBody>

          </Card>: (notificationTasks && notificationText && NotificationData)? 
             <>   <Card style={{margin:'2%'}}>
                    <CardHeader>VR Details</CardHeader>
                    <CardBody>
                        {VRDetailHeader}

                  
                        <div>
  <Nav tabs style={{margin:'1%'}}>
    <NavItem>
      <NavLink
        className="active"
        onClick={() =>toggle('1')}
        className={classnames({ active: activeTab === "1" })}
      >
        VR Details
      </NavLink>
    </NavItem>
    <NavItem>
      <NavLink
         className={classnames({ active: activeTab === "2" })}
        onClick={() =>toggle('2')}
      >
        Tasks
      </NavLink>
    </NavItem>
    <NavItem>
      <NavLink
         className={classnames({ active: activeTab === "3" })}
        onClick={() =>toggle('3')}
      >
        Attachments
      </NavLink>
    </NavItem>
  </Nav>
  <TabContent activeTab={activeTab}>
    <TabPane tabId="1">

    <Row>
        <Col>
         <Form>
                <FormGroup row>
                    <Label
                    for="materialNumber"
                    sm={2}
                    >
                    Material # / Revision
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                        {selectedNotification.node.MaterialNum} / {selectedNotification.node.RevLvl}
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    Batch
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.Batch)?selectedNotification.node.Batch:'N/A'}  
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    Complaint Quantity
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.ComplaintQty)?selectedNotification.node.ComplaintQty:'N/A'}   
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    Serial #
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.SerialNum)?selectedNotification.node.SerialNum:'N/A'} 
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    Unit Of'Measure #
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.UnitOfMeasure)?selectedNotification.node.UnitOfMeasure:'N/A'} 
                    </Col>
                </FormGroup>

                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    Diagnosis
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.SerialNum)?selectedNotification.node.SerialNum:'N/A'}   
                    </Col>
                </FormGroup>

                <FormGroup row>
                    <Label
                    for="examplePassword"
                    sm={2}
                    >
                    Purchase Order #
                    </Label>
                    <Col sm={10} style={{display:'flex', alignItems:'center'}}>
                    {(selectedNotification.node.PurchaseOrderNum)?selectedNotification.node.PurchaseOrderNum:'N/A'}  
                    </Col>
                </FormGroup>
  </Form>
  </Col>
  <Col>
            <Card>
                <CardHeader>Notes</CardHeader>
                <CardBody>
                    <ul>{notesHTML}</ul>
                </CardBody>
            </Card>
  </Col>
    </Row>
  

        
         
   
    </TabPane>
    <TabPane tabId="2">
    <Card style={{margin:'2%'}}>
            <CardHeader>VR Notifications</CardHeader>

            <CardBody>
            <div className="table-responsive">
                          <DataTable
                            title="Google Sheets-esqe"
                            columns= {taskcolumns}
                            data={notificationTasks}
                            highlightOnHover                 
                            pointerOnHover
                            pagination
                          />
                  </div>

            </CardBody>

          </Card>
    </TabPane>
    <TabPane tabId="3">

            <FileUploaderObjGeneric mode="VRNotifications" header={selectedNotification} data={selectedNotification}/>
    </TabPane>
  </TabContent>
</div>

                        </CardBody>

                    </Card></>
            : null}

      </ReactCSSTransitionGroup>

      {(showLoading) ? 
      <Modal isOpen={showLoading} style={{ backgroundColor: "transparent" }}>
        <ModalBody>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: "20px",
              verticalAlign: "center",
            }}
          >
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                verticalAlign: "center",
              }}
              class="loader"
            ></div>
            Loading Notifications .....
          </div>
        </ModalBody>
      </Modal>
      : null}
      
      </Fragment>

)
}

export default (withRouter(withAuth(VRNotifications)))
